module.exports = __webpack_public_path__ + "img/Like.7f4d8d39.svg";